'use client'

import { useEffect, useState } from 'react'
import { Analytics } from '@cerifi/analytics'
import { BCProduct } from '@cerifi/ecomm/bigcommerce/types/product'
import { Card } from '@cerifi/ui/components/card'
import { Container } from '@cerifi/ui/components/container'
import { Divider } from '@cerifi/ui/components/divider'

import { EnrollmentFooter } from '@/components/enrollment/enrollment-footer'
import { EnrollmentHeader } from '@/components/enrollment/enrollment-header'
import { EnrollmentMainCard } from '@/components/enrollment/enrollment-main-card'
import { EnrollmentDobPicker } from '../enrollment-dob-picker'
import { EnrollmentTextbookAddon } from '../enrollment-textbook-addon'
import { UniversityEnrollmentPicker } from '../enrollment-university-picker'

interface SelfStudy {
  eBook: BCProduct
  eBookDaltonReview: BCProduct
  textBookAddOn: BCProduct
  /** Used to get the discount you are getting on the dalton review if you choose that bundle */
  originalDaltonReview: BCProduct
}

export const CfpSelfStudy = (props: SelfStudy) => {
  const [product, setProduct] = useState(props.eBookDaltonReview)
  const [isDaltonReview, setIsDaltonReview] = useState(true)
  const [addTextBook, setAddTextBook] = useState(false)

  /** User is switching to add The Dalton Review or remove it */
  const changeProduct = (isPro: boolean) => {
    setIsDaltonReview(isPro)
    setProduct(isPro ? props.eBookDaltonReview : props.eBook)
  }

  useEffect(() => {
    if (product) {
      Analytics.ViewItem(product.id, product.sku, product.name, product.price)
    }
  }, [product])

  return (
    <>
      <Container className="pb-20">
        <EnrollmentHeader tag="CFP Education Program" />

        <EnrollmentMainCard
          title="Self Study Course"
          innerTags={['CFP EXAM PREP', 'MONEY-BACK GUARANTEE']}
          isDaltonReviewChecked={isDaltonReview}
          daltonReviewChange={(c) => changeProduct(c)}
          showDaltonReview
          allowPaymentPlans={true}
          tag="CFP EDUCATION PROGRAM"
          text="Designed with one goal in mind – your success – The Dalton Review is the proven roadmap and 4 month program that will guide you towards passing the prestigious CFP® exam with confidence."
          price={props.eBook.price}
          reviewPrice={
            /** Ebook Dalton Review is a bundle under one sku of the eBook and The Dalton Review. This is making it so it shows
             * just the price of the dalton review.
             */
            props.eBookDaltonReview.price - props.eBook.price
          }
          originalReviewPrice={props.originalDaltonReview.price}
        />

        <div className="sm:mb-20">
          <h3 className="mt-12 text-2xl">Enroll in Your Course</h3>

          <Card className="mt-6">
            <EnrollmentTextbookAddon
              checked={addTextBook}
              onCheckedChange={(v) => setAddTextBook(v)}
              product={props.textBookAddOn}
            />

            <Divider className="my-6" />

            <UniversityEnrollmentPicker />
            <EnrollmentDobPicker />
          </Card>
        </div>
      </Container>

      <EnrollmentFooter
        hasUniversity
        tag="CFP Education"
        title="Self Study"
        product={product}
        addOnProduct={addTextBook ? props.textBookAddOn : null}
      />
    </>
  )
}
